import React from 'react';

const VARIANTS = {
  in: 'bg-success-bg text-success-tx',
  out: 'bg-out-bg text-out-tx',
  none: 'bg-neutral-bg text-neutral-tx',
  leave: 'bg-light-gold text-bronze',
};

const LABELS = {
  in: 'Checked in',
  out: 'Checked out',
  none: 'Not checked in yet',
  leave: 'On leave',
};

const COMPACT_LABELS = {
  in: 'IN',
  out: 'OUT',
  none: 'NOT YET',
  leave: 'ON LEAVE',
};

export default function StatusPill({ status, compact = false }) {
  const labels = compact ? COMPACT_LABELS : LABELS;
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full font-medium flex-shrink-0 ${
        compact ? 'px-2 py-0.5 text-[10px] tracking-wide' : 'px-3 py-1 text-sm'
      } ${VARIANTS[status]}`}
    >
      {labels[status]}
    </span>
  );
}
